// extracted by mini-css-extract-plugin
module.exports =  {"defaultImage":"we1j_p"};